import React, { useState } from 'react';
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { FormControl, RadioGroup, FormControlLabel, Radio, Button, Box } from "@mui/material";
import { SelectedIcon, UnSelectedIcon } from "../../../../Shared/components/Icons/selectedIcon";
import customStyles from "../../../../../assets/styles/customStyles";
import clsx from "clsx";
import { Space } from "antd";


export const FilterProductGroup = (props) => {
    const { clientProductcatalogueDetails, clientProductcategoryDetails, customObject,
        handleSubmit, productGroupDetails, handleCloseMobile, topBar, checkComponentPermission, roleManagement } = props;
    const classes = customStyles();
    const [mobileFilter, setMobileFilter] = useState(topBar);

    const handleMobileSubmit = (e) => {
        e.preventDefault();
        handleSubmit(mobileFilter);
    }

    const handleTypeChange = (value) => {
        setMobileFilter({
            ...mobileFilter, type: value
        })
    }

    return (
        <Box
            component='form'
            autoComplete='off'
            onSubmit={(e) => handleMobileSubmit(e)}
            className={clsx(classes.customForm, classes.removeUnderline)}>
            <div className={classes.customFormFlex}>
                {
                    roleManagement !== '' && checkComponentPermission('My Products', 'Action', 'Product Filter') &&
                    <>
                        <FormControl
                            variant={'standard'}
                            className={clsx(classes.customRadioButton)}
                            fullWidth>
                            <RadioGroup
                                row
                                value={mobileFilter?.type}
                                onChange={(e) => handleTypeChange(e.target.value)}>
                                <FormControlLabel value="All"
                                    control={<Radio
                                        checkedIcon={<UnSelectedIcon />}
                                        icon={<SelectedIcon />}
                                    />} label="All" />
                                <FormControlLabel value="Catalogue"
                                    control={<Radio
                                        checkedIcon={<UnSelectedIcon />}
                                        icon={<SelectedIcon />}
                                    />} label="Catalogue" />
                                <FormControlLabel value="Category"
                                    control={<Radio
                                        checkedIcon={<UnSelectedIcon />}
                                        icon={<SelectedIcon />}
                                    />} label="Category" />
                            </RadioGroup>
                        </FormControl>
                        {
                            mobileFilter?.type !== 'All' && <>
                                {
                                    mobileFilter?.type === 'Catalogue' ?
                                        <AutoCompleteComponent
                                            name={"All Catalogue"}
                                            heads={[
                                                { 'key': 'catalogueName', 'name': 'Name' },
                                                { 'key': 'cataloguePrefix', 'name': 'Prefix' }
                                            ]}
                                            details={clientProductcatalogueDetails}
                                            parentValue={customObject(clientProductcatalogueDetails, mobileFilter?.catalogueId)}
                                            position={"bottom"}
                                            onChangeText={(data) => {
                                                if (data === '') {
                                                    setMobileFilter({
                                                        ...mobileFilter, catalogueId: ''
                                                    });
                                                }
                                            }}
                                            onChange={(data) => {
                                                setMobileFilter({
                                                    ...mobileFilter, catalogueId: data.id
                                                });
                                            }}
                                            customClasses={classes.margin20t}
                                        /> :
                                        <AutoCompleteComponent
                                            name={["All Category"]}
                                            heads={[
                                                { 'key': 'categoryName', 'name': 'Name' },
                                                { 'key': 'parent', 'name': 'Parent', 'relation': 'categoryName' }
                                            ]}
                                            details={clientProductcategoryDetails}
                                            parentValue={customObject(clientProductcategoryDetails, mobileFilter?.categoryId)}
                                            position={"bottom"}
                                            onChangeText={(data) => {
                                                if (data === '') {
                                                    setMobileFilter({
                                                        ...mobileFilter, categoryId: ''
                                                    });
                                                }
                                            }}
                                            onChange={(data) => {
                                                setMobileFilter({
                                                    ...mobileFilter, categoryId: data.id
                                                });
                                            }}
                                            customClasses={classes.margin20t}
                                        />
                                }
                            </>
                        }

                    </>
                }
                {
                    roleManagement !== '' && checkComponentPermission('My Products', 'Action', 'All Group') &&
                    <AutoCompleteComponent
                        name={"All Product Group"}
                        heads={[{ 'key': 'name', 'name': 'Name' }]}
                        details={productGroupDetails}
                        parentValue={customObject(productGroupDetails, mobileFilter?.groupId)}
                        position={"bottom"}
                        customClasses={classes.margin30t}
                        onChangeText={(data) => {
                            if (data === '') {
                                setMobileFilter({
                                    ...mobileFilter, groupId: ''
                                });
                            }
                        }}
                        onChange={(data) => {
                            setMobileFilter({
                                ...mobileFilter, groupId: data.id
                            });
                        }}
                    />

                }

            </div>
            <div className={clsx(classes.btnParent)}>
                <Space direction="horizontal" align="center"
                    size={[10, 10]}>
                    <Button
                        key="save"
                        color="primary"
                        variant="contained"
                        type="submit"
                        className={classes.modalBtn}
                    >Confirm</Button>
                    <Button
                        key="save"
                        color="primary"
                        variant="contained"
                        onClick={() => { handleCloseMobile() }}
                        className={clsx(classes.AddMoreBtn)}
                    >Cancel</Button>
                </Space>
            </div>
        </Box>

    )
}